import { UserDto } from '../api/core';
import { LoggedInUser, UserRoles } from '../users';

export interface FirmwareState {
    loading: number;
    firmwares: Firmware[];
}

export enum FirmwareActionTypes {
    LOADING = '@liebherr/firmwares/loading',
    LOADING_DONE = '@liebherr/firmwares/loading_done',
    LOAD_FIRMWARES = '@liebherr/firmwares/load_firmwares',
    LOADED_FIRMWARES = '@liebherr/firmwares/loaded_firmwares',
    ADD_FIRMWARE = '@liebherr/firmwares/add_firmware',
    DELETE_FIRMWARE = '@liebherr/firmwares/delete_firmware',
    RELEASE_FIRMWARE = '@liebherr/firmwares/release_firmware',
}

export const firmwareFeatureKey = 'firmwares';

export class Firmware {
    id?: number;
    version?: string;
    releasedAt?: string;
    releasedBy?: UserDto;
    activeOn: string;
    routerType?: string;
    vendor?: string;
    hasFile: boolean;
    constructor(dto: any) {
        this.id = dto.id;
        this.version = dto.version;
        this.releasedAt = dto.releasedTime;
        this.releasedBy = dto.releasedBy;
        this.activeOn = dto.released ? dto.routerType.name : undefined;
        this.routerType = dto?.routerType?.name;
        this.vendor = dto?.routerType?.vendor;
        this.hasFile = dto.hasFile || false;
    }
}

export interface CreateFirmwareDto {
    version: string;
    file: File;
    routerTypeId: number;
}

export enum FirmwareColumns {
    ACTIVE = 'ACTIVE_ON',
    VERSION = 'VERSION',
    RELEASED_AT = 'RELEASED_AT',
    RELEASED_BY = 'RELEASED_BY',
    ACTIONS = 'ACTIONS',
    ROUTERTYPE = 'ROUTER_TYPE',
    VENDOR = 'VENDOR',
    HAS_FILE = 'HAS_FILE',
}

export function getFirmwarePermissions(
    action: 'loadAll' | 'addFirmware' | 'releaseFirmware' | 'deleteFirmware',
    loggedInUser?: LoggedInUser
) {
    switch (action) {
        case 'loadAll': {
            return [UserRoles.LCO_GET_3];
        }
        case 'addFirmware': {
            return [UserRoles.LCO_POST_3];
        }
        case 'releaseFirmware': {
            return [UserRoles.LCO_POST_3];
        }
        case 'deleteFirmware': {
            return [UserRoles.LCO_DELETE_3];
        }

        default: {
            return [];
        }
    }
}
